export const LINKEDIN = 'https://www.linkedin.com/in/jonas-dormaels-650427185/';
export const GITHUB = 'https://github.com/JonasDormaels';
